import {
  type MultiSelectOption,
  InputGroupV2,
  UniversalSelect,
} from '@equip.health/ui';

import { GroupClassAttendeeTypes } from '~/lib/constants/groupClasses.constants';
import {
  type GroupClassBaseFieldProps,
  GROUP_CLASS_ACCORDION_TOP_LEVEL_ID,
} from '~/lib/types/classes/GroupClassAccordion';

export const GroupClassAttendeeTypesField = ({
  value,
  isDisabled,
  isEditMode,
  isReadOnly = false,
  leftIcon,
  onChange,
  placeholder,
}: GroupClassBaseFieldProps<string[]>) => {
  const handleMultiSelectV2 = (values: MultiSelectOption[]) => {
    onChange(values.map((v) => v.value));
  };

  const attendeeRoleOptions =
    GroupClassAttendeeTypes?.map((attendeeType) => ({
      isDisabled,
      isEditMode,
      label: attendeeType,
      value: attendeeType.toLocaleUpperCase(),
    })) ?? [];

  const readOnlyProps = isReadOnly ? { inputValue: value?.join(', ') } : {};
  return (
    <InputGroupV2
      id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__attendee-types`}
      label="Attendee roles"
    >
      <UniversalSelect
        id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__attendee-types-v2`}
        isSingleSelect={false}
        onChange={handleMultiSelectV2}
        options={attendeeRoleOptions}
        leftIcon={leftIcon}
        placeholder={placeholder}
        isReadOnly={isReadOnly}
        value={attendeeRoleOptions.filter((option) =>
          value?.includes(option.value),
        )}
        withCheckBox
        {...readOnlyProps}
      />
    </InputGroupV2>
  );
};
